import { Box, Button, Typography, useTheme } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

import Link from "../../atoms/mui/Link";

import { analyticsTrack } from "../../../helpers/analytics";

const trackBannerClick = () =>
  analyticsTrack("explorer_persistent_upgrade_clicked", {
    fromPath: window.location.pathname
  });

const UpgradeBanner = () => {
  const { palette } = useTheme();

  return (
    <Box
      px={{ xs: 2, md: 3 }}
      py={0.75}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      style={{
        backgroundColor: palette.primary.main,
        gap: 12,
        minHeight: 48,
        color: palette.common.white
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        style={{ gap: 8, minWidth: 0, flex: 1 }}
      >
        <Typography variant="subtitle2" color="inherit" noWrap>
          Footprint Confidence: Low
        </Typography>
        <Typography
          variant="caption"
          color="inherit"
          noWrap
          sx={{ display: { xs: "none", md: "inline" } }}
        >
          Explorer uses benchmark estimates — upgrade to Navigator for
          measurement-grade data.
        </Typography>
      </Box>
      <Link href="/explorer/upgrade" onClick={trackBannerClick}>
        <Button
          variant="contained"
          color="secondary"
          size="small"
          endIcon={
            <FontAwesomeIcon icon={faArrowRight} style={{ fontSize: 12 }} />
          }
        >
          See plans
        </Button>
      </Link>
    </Box>
  );
};
export default UpgradeBanner;
